export const staticText = {
  inputs: {
    firstName: {
      id: "given_name",
      label: "First Name",
      validation: {
        required: "First Name is required",
      },
    },
    lastName: {
      id: "family_name",
      label: "Last Name",
      validation: {
        required: "Last Name is required",
      },
    },
    company: {
      id: "custom:company_name",
      label: "Company",
    },
    email: {
      id: "email",
      label: "Email",
      validation: {
        invalidEmail: "Please enter a valid email",
        required: "Email address is required",
      },
    },
    phoneNumber: {
      id: "phoneNumber",
      label: "Phone Number",
      validation: {
        required: "Phone number is required",
        invalid: "Please enter a valid phone number",
      },
      prefix: {
        id: "phoneNumberPrefix",
        validation: {
          required: "Required",
          blacklisted:
            "This authentication method is not yet supported for this region. Please use Google Authenticator/TOTP instead.",
        },
      },
    },
    password: {
      label: "Password",
      info: {
        hidePassword: "Hide password",
        showPassword: "Show password",
      },
      currentPassword: {
        id: "currentPassword",
        validation: {
          rules: {
            required: "Current password is required",
          },
        },
      },
      newPassword: {
        id: "newPassword",
        label: "New Password",
        validation: {
          title: "Your password must contain",
          invalid: "Password is invalid",
          rules: {
            required: "Password is required",
            minimum: "8 characters minimum",
            uppercase: "1 upper case character",
            lowercase: "1 lower case character",
            digit: "1 special character",
            specialCharacter: "1 number",
            match: "Passwords must match",
          },
        },
      },
      confirmPassword: {
        id: "confirmPassword",
        label: "Confirm Password",
        newLabel: "Confirm New Password",
        validation: {
          required: "Confirm Password is required",
          passwordsMustMatch: "Your passwords do not match.",
        },
      },
      success: "Your password is secure, you're good to go",
    },
    verificationCode: {
      id: "code",
      label: "Verification Code",
      validation: {
        required: "Verification Code is required",
        sixDigits: "Verification Code must be 6 numeric digits",
      },
    },
    adminNotes: {
      id: "adminNotes",
      label: "Admin Notes",
      validation: {
        required: "Admin notes are required",
      },
    },
    sub: {
      id: "cognito-sub",
      label: "Sub",
    },
    picture: {
      id: "picture",
      label: "Profile Picture",
    },
    workspace: {
      id: "workspace",
      label: "workspacename",
      validation: {
        required: "Workspace name is required",
        noSpecial:
          "Use only lowercase letters, numbers, hyphens(-), or underscores(_). No spaces or other special characters allowed.",
      },
    },
  },
  buttons: {
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    submit: "Submit",
    verify: "Verify",
  },
  components: {
    alertMessage: { defaultSuccessMessage: "Success" },
    appNavigation: {
      logo: { ariaLabel: "Navigate to Dashboard" },
      userMenu: {
        id: "user-menu",
        ariaLabel: "Toggle User Menu",
        items: {
          signOut: "Sign Out",
          viewJwt: "View JWT",
        },
      },
    },
    emptyState: { defaultText: "No results" },
    errorFlag: {
      defaultHeader: "Something went wrong",
      defaultMessage: "If the problem persists, please reach out to support.",
      buttons: { signOut: "Back to home" },
    },
    profilePictureEditor: {
      scaleLabel: "Scale",
      rotationLabel: "Rotate",
      fileButton: "Choose File",
      newFileButton: "Choose New File",
      adminNotesModal: {
        header: "Edit User's Profile Picture",
        description:
          "Please provide a reason for editing this user's profile picture:",
        profilePictureReason: "Reason for editing user's profile picture...",
      },
    },
    row: {
      appRow: {
        homeUrl: "Go to App",
        noRoles: "No assigned roles",
        defaultLogoAlt: "App Logo",
      },
    },
    tocNav: {
      navItemAriaLabel: "Scroll to {label}",
    },
    userApplications: {
      header: "Applications",
      noApps: "No applications found",
      anchorHash: "applications",
    },
    secretText: {
      defaultPlaceholder: "•••••••••",
    },
  },
  pages: {
    route404: {
      header: "404 Not Found!",
      message:
        "We couldn't find a page for that url... If you believe this to be an error, try refreshing the page. If you believe this message was shown in error, please reach out to support.",
    },
  },
} as const;
